export default "__VITE_ASSET__CrVCwo9m__"